import {ThemeProvider} from '@mui/system';
import {SnackbarProvider} from '@verihubs/pandora';
import {CookiesProvider} from 'react-cookie';
import {BrowserRouter} from 'react-router-dom';
import {AppRoutes} from './routes';
import {AppTheme} from './theme';

function App() {
  return (
    <SnackbarProvider>
      <ThemeProvider theme={AppTheme}>
        <CookiesProvider>
          <BrowserRouter basename="/">
            <AppRoutes />
          </BrowserRouter>
        </CookiesProvider>
      </ThemeProvider>
    </SnackbarProvider>
  );
}

export default App;
